'use strict';

/**
 * @ngdoc service
 * @name webAgro1App.MapaPropriedadeService
 * @description
 * # MapaPropriedadeService
 * Factory in the webAgro1App.
 */

var STROKE_POLYGON = {
  color: '#FFFFFF',
  weight: 2,
  opacity: '1.0'
};
var FILL_POLYGON = {
  color: '#000',
  opacity: '0.2'
};
var STROKE_POLYGON_CLICK = {
  color: '#33336f',
  weight: 3,
  opacity: '1.0'
};
var FILL_POLYGON_CLICK = {
  color: '#00BFFF',
  opacity: '0.5'
};

angular.module('webAgro1App').factory('MapaPropriedadeService', function($rootScope, filterFilter) {
  return {
    getPropertyMap: function(propriedade) {
      propriedade = propriedade || $rootScope.currentPropriedade;

      var object = {
        map: {
          center: {
            latitude: 45,
            longitude: -73
          },
          zoom: 2,
          options: {
            streetViewControl: false,
            optimized: true,
            zoomControl: false,
            mapTypeControl: false,
            mapTypeId: google.maps.MapTypeId.SATELLITE
          },
          bounds: {}
        },
        polygons: []
      };

      object.polygons = this.getPolygons(propriedade);

      return object;
    },

    getPolygons: function(propriedade) {
      var polygons = [];
      var id = 0;
      for (var i = propriedade.glebas.length - 1; i >= 0; i--) {
        var gleba = propriedade.glebas[i];
        var coordinates = gleba.coordinates;

        for (var j = coordinates.length - 1; j >= 0; j--) {
          var transformed = coordinates[j].map(function(coordinate) {
            return {
              latitude: coordinate[1],
              longitude: coordinate[0]
            };
          });
          polygons.push({
            idKey: id,
            title: gleba.descricao,
            path: transformed,
            stroke: STROKE_POLYGON,
            fill: FILL_POLYGON,
            gleba: gleba,
            visible: true
          });
          id++;
        }
      }

      return polygons;
    },

    resetPolygonsMap: function(polygons) {
      for (var i = polygons.length; i--;) {
        polygons[i].stroke = STROKE_POLYGON;
        polygons[i].fill = FILL_POLYGON;
        polygons[i].visible = true;
      }
      return polygons;
    },

    contrastPolygons: function(polygons, glebas, withFill) {
      var result = [];
      glebas = Array.isArray(glebas) ? glebas : [glebas];
      for (var i = polygons.length; i--;) {
        if (glebas && filterFilter(glebas, {id: polygons[i].gleba.id}, true)[0]) {
          polygons[i].stroke = STROKE_POLYGON_CLICK;
          polygons[i].fill = withFill ? FILL_POLYGON_CLICK : FILL_POLYGON;
          polygons[i].visible = true;
          result.push(polygons[i]);
        }
      }
      return result;
    },

    getPolygonsGleba: function(polygons, gleba) {
      var polygonsResult = [];
      for (var i = polygons.length; i--;) {
        if (gleba && polygons[i].gleba.id === gleba.id) {
          polygonsResult.push(polygons[i]);
        }
      }
      return polygonsResult;
    }
  };
});
